import React from "react";

import {
  Container,
  ScreenContainer,
  ScreenHeader,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
} from "../components/wombat-ui";
import { AnalyticsIcon } from "../components/icons";

import useTranslations from "../hooks/useTranslations";

import SkillsAnalytics from "../components/statistics/SkillsAnalytics";
import EvaluationsAnalytics from "../components/statistics/EvaluationsAnalytics";
import QuestionsAnalytics from "../components/statistics/QuestionsAnalytics";

const StatisticsScreen = () => {
  const t = useTranslations();

  return (
    <ScreenContainer>
      <ScreenHeader
        title={t("statistics.statistics")}
        description={t("statistics.statisticsDescription")}
        icon={AnalyticsIcon}
      ></ScreenHeader>

      <Container className="flex flex-col space-y-4">
        <Tabs>
          <TabList>
            <Tab>{t('statistics.skillMapping')}</Tab>
            <Tab>{t('statistics.evaluations')}</Tab>
            <Tab>{t('statistics.questions')}</Tab>
          </TabList>
          <TabPanels>
            <TabPanel className="bg-white rounded-sm">
              <SkillsAnalytics />
            </TabPanel>
            <TabPanel className="bg-white rounded-sm">
              <EvaluationsAnalytics />
            </TabPanel>
            <TabPanel className="bg-white rounded-sm">
              <QuestionsAnalytics />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Container>
    </ScreenContainer>
  );
};

export default StatisticsScreen;
